import React, { useEffect, useRef, useState } from "react";
import useStyles from "./styles";

const PickleCard = ({ user, sportArea, text, key }) => {
  const classes = useStyles();

  return (
    <div key={key} className={classes.pickleCard}>
      <div className={classes.cardHeader}>
        <h2 className={classes.cardTopText}>{user}</h2>
        <p className={classes.cardParaText}>{sportArea}</p>
      </div>
      <div className={classes.cardBody}>
        <p>{text}</p>
      </div>
    </div>
  );
};

const cardData = [
  {
    user: "Sail Sabnis",
    sportArea: "The Pickle Point, Pune",
    text: "Huge thanks to KheloMore for powering the WPBL x KheloMore Starter Camp at The Pickle Point! With 50+ excited participants, expert coaching, and great energy, it was a perfect start. We're proud to partner with KheloMore to grow pickleball in Pune—this is just the beginning of something big!",
  },
  {
    user: "Subrato",
    sportArea: "LeNoah Sportsplex, Pune",
    text: "KheloMore has been our trusted booking partner since Day 1 at LeNoah Sportsplex. Seamless bookings, timely payments, and a responsive team make the experience effortless. Special thanks to Saifuddin, Parag, and the entire team for their consistent support. Grateful to have such a reliable partner. Keep it up!",
  },
  {
    user: "Vishal Bhondwe",
    sportArea: "Swamy Badminton Academy, Pune",
    text: "Partnering with KheloMore has truly transformed Swamy Badminton Academy. Daily bookings have increased, player engagement is strong, and slot management is seamless. Their platform brings the visibility and convenience every venue needs. If you run a badminton court, I highly recommend KheloMore—it’s a complete game-changer!",
  },
  {
    user: "Jasmine Ganatra",
    sportArea: "Business Head, BKC Sports Avenue, Mumbai",
    text: "Thanks to the KheloMore app, we’ve seen a rise in footfall for both badminton and basketball. It’s helped us attract new players and manage corporate bookings with ease. The team is always supportive and responsive. Overall, it’s been a smooth and rewarding partnership—we’re glad to be on board!",
  },
  {
    user: "Kevin Dharia",
    sportArea: "Urban Sports, Mumbai",
    text: "Urban Sports has been using KheloMore App for managing our bookings for the last 4 years. All our customers now prefer to book using KheloMore App. KheloMore Partner App also allows quick access to us for any revenue updates, occupancy analysis , booking cancellations etc. Our venue managers have gotten used to this method and no longer use registers and hand notes for taking bookings.",
  },
  {
    user: "Mukesh",
    sportArea: "Easy Court Pickleball Experience Center, Bengaluru",
    text: "Akash of Khelomore has been supporting and hand holding from the day we met. We could not have asked for a better partner being a start up. We are planing multiple Easy Court Experience Centers around Bangalore and All around India and Khelomore will be our first choice. Thank you Akash. Thank you Khelomore",
  },
  {
    user: "Owner",
    sportArea: "Baroda Sports Arena, Vadodara",
    text: "We’re not just getting bookings — we’re building a pickleball movement. KheloMore gave us the tools to scale fast.",
  },
  {
    user: "Owner",
    sportArea: "Dink It PickleBall Club, Vadodara",
    text: "KheloMore turned our courts into a calendar of action. Tournaments, open play, coaching — all booked, all smooth. KheloMore isn’t just a platform — it’s our court manager, marketer, and matchmaker rolled into one.",
  },
];

const PickleCarousel = () => {
  // const [items, setItems] = useState([...cardData, cardData[0]]);
  const [items, setItems] = useState(cardData); // ← Removed duplicate cardData[0]

  const [isHovered, setIsHovered] = useState(false);
  const [index, setIndex] = useState(0);
  const containerRef = useRef(null);
  const scrollRef = useRef(0);
  const classes = useStyles();

  useEffect(() => {
    if (isHovered) return;

    const container = containerRef.current;
    if (!container) return;

    const totalCards = items.length;
    const cardWidth = container.offsetWidth * 0.8;
    const gap = 20;
    const scrollStep = cardWidth + gap;

    const interval = setInterval(() => {
      const nextIndex = (index + 1) % totalCards;
      const scrollLeft = scrollStep * nextIndex;

      scrollRef.current = scrollLeft;
      setIndex(nextIndex);
      container.scrollTo({ left: scrollLeft, behavior: "smooth" });
    }, 5000);

    return () => clearInterval(interval);
  }, [items, isHovered, index]);

  const handleDotClick = (dotIndex) => {
    const container = containerRef.current;

    const cardWidth = container.offsetWidth * 0.8;
    const gap = 20;
    const scrollTo = (cardWidth + gap) * dotIndex;

    scrollRef.current = scrollTo;
    container.scrollTo({ left: scrollTo, behavior: "smooth" });
    setIndex(dotIndex);
  };

  return (
    <>
      <div
        className={classes.carouselContainer}
        ref={containerRef}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onTouchStart={() => setIsHovered(true)}
        onTouchEnd={() => setIsHovered(false)}
      >
        <div className={classes.carouselTrack}>
          {items.map((card, index) => (
            <PickleCard key={index} {...card} />
          ))}
        </div>
      </div>
      <div className={classes.carouselDots}>
        {cardData.map((_, i) => (
          <span
            key={i}
            className={`${classes.dot} ${i === index ? classes.activeDot : ""}`}
            onClick={() => handleDotClick(i)}
          ></span>
        ))}
      </div>
    </>
  );
};

export default PickleCarousel;
